import { TOGGLE_OPTIONAL_TEXT, CHANGE_TEXT } from './constants';
import { createReducer, baseReduceHandler } from '../reducer';
export const reducer = createReducer({}, {
    [CHANGE_TEXT]: baseReduceHandler,
    [TOGGLE_OPTIONAL_TEXT]: baseReduceHandler,
});
//# sourceMappingURL=reducer.js.map